enum GuiidePlusView {
  Dashboard,
  Providers,
  PensionManagement,
  Advisers,
  GuaranteedIncome,
  StatePensionHelp,
  LumpsSumsAndTax,
  BenefitsAndCredits,
  EquityRelease,
  PartnersIncome,
  WhyPayMore,
  OtherWaysToSave,
  HelpAndEducation,
  FinancialCoaching,
  RetirementChoicesHL,
  LumpSumsHL,
  MixingOptionsHL,
  GuaranteedIncomeHL,
  AdviserHL,
  FlexibleIncomeHL
}

export default GuiidePlusView;
